
/*
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */

$.eachComponent('.datastorage-explorer', function(explorer) {

});
